/* eslint-disable react/prop-types */
import React from "react";
import Link from "../../Link";

const MultiOptionMenu = ({ submenu, isMobile }) => {
  return (
    <div className="border-div">
      <div className={`has-submenu ${!isMobile ? "border-bottom-right" : ""}`}>
        {submenu?.map(({ url, pageId, label }) => (
          <div className="single-center-link" key={pageId}>
            <Link
              to={url}
              className="!p-0 !bg-[#f6f6fe] bg-cover bg-center bg-navbarbg  w-full h-[118px] flex flex-col items-center justify-center rounded-lg">
              <h4 className="body-font font-semibold !m-0 text-center hover:text-cf-primary w-full">
                {label}
              </h4>
              <span className="font-inter text-sm font-normal leading-5 text-center text-cf-primary w-full">
                Learn More »
              </span>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MultiOptionMenu;
